var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27515 9V10H7.6369L7.91493 9.76856L7.27515 9ZM7.27515 15L7.91493 14.2314L7.6369 14H7.27515V15ZM10.645 17.8052L11.2848 17.0366H11.2848L10.645 17.8052ZM10.645 6.19485L11.2848 6.96341L11.2848 6.96341L10.645 6.19485ZM7.27515 8H3.5V10H7.27515V8ZM3.5 8C2.67157 8 2 8.67157 2 9.5H4C4 9.77614 3.77614 10 3.5 10V8ZM2 9.5V14.5H4V9.5H2ZM2 14.5C2 15.3284 2.67157 16 3.5 16V14C3.77614 14 4 14.2239 4 14.5H2ZM3.5 16H7.27515V14H3.5V16ZM6.63538 15.7686L10.0052 18.5737L11.2848 17.0366L7.91493 14.2314L6.63538 15.7686ZM10.0052 18.5737C10.5671 19.0414 11.2857 19.0835 11.836 18.8938C12.3796 18.7063 13 18.1869 13 17.338H11C11 17.2283 11.0441 17.1323 11.0954 17.0717C11.1398 17.0192 11.1775 17.0053 11.184 17.003C11.1922 17.0002 11.199 16.9991 11.2104 17.0008C11.2251 17.0029 11.2545 17.0114 11.2848 17.0366L10.0052 18.5737ZM13 17.338V6.66205H11V17.338H13ZM13 6.66205C13 5.81307 12.3796 5.29367 11.836 5.10624C11.2857 4.91649 10.5671 4.95856 10.0052 5.42628L11.2848 6.96341C11.2545 6.98859 11.2251 6.99711 11.2104 6.99923C11.199 7.00087 11.1922 6.99982 11.184 6.997C11.1775 6.99475 11.1398 6.98077 11.0954 6.9283C11.0441 6.86772 11 6.77174 11 6.66205H13ZM10.0052 5.42628L6.63538 8.23144L7.91493 9.76856L11.2848 6.96341L10.0052 5.42628Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 2,
    height: 6,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 2,
    height: 12,
    rx: 1,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.37edabfb.svg";
export { ForwardRef as ReactComponent };